const URL_SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:/i

export function normalizeWebsiteUrlInput(value: string): string {
  const trimmed = value.trim()

  if (!trimmed || URL_SCHEME_PATTERN.test(trimmed)) {
    return trimmed
  }

  return `https://${trimmed}`
}

export function isValidWebsiteUrl(value: string): boolean {
  try {
    const parsed = new URL(normalizeWebsiteUrlInput(value))
    return parsed.protocol === "http:" || parsed.protocol === "https:"
  } catch {
    return false
  }
}
